import { getNow, getPreviousYear, isAfter } from '@kathondvla/sri-client/date-utils';
import { emailAddressPattern as regexEmailAddressPattern } from './regexPatterns';

const currentYear = new Date().getFullYear();

export const emailAddressPattern = regexEmailAddressPattern;

export const getDateOfBirthFromRegistrationNumber = (rn) => {
  const yearDigits = rn.substring(1, 3);
  return `${
    (yearDigits <= currentYear.toString().substring(2, 4) ? '20' : '19') + yearDigits
  }-${rn.substring(3, 5)}-${rn.substring(5, 7)}`;
};

export const getDateOfBirthFromNationalIdentityNumber = (rn) => {
  const yearDigits = rn.substring(0, 2);
  const firstTwoDigitsOfYearOfBirth =
    yearDigits <= currentYear.toString().substring(2, 4)
      ? currentYear.toString().substring(0, 2)
      : parseInt(currentYear.toString().substring(0, 2), 10) - 1;
  return `${firstTwoDigitsOfYearOfBirth + yearDigits}-${rn.substring(2, 4)}-${rn.substring(4, 6)}`;
};

export const validateRegistrationNumber = (registrationNumber) => {
  if (
    parseInt(registrationNumber.substr(0, 9), 10) % 97 !==
    parseInt(registrationNumber.substr(9), 10) % 97
  ) {
    return {
      code: 'invalid.controlnumber',
      message: 'Dit is geen geldig stamboeknummer',
    };
  }
  return null;
};

export const validateDateOfBirthAndRegistrationNumber = (dateOfBirth, rn, rnValid) => {
  if (!rn || !dateOfBirth || !rnValid) {
    return null;
  }
  return getDateOfBirthFromRegistrationNumber(rn) === dateOfBirth
    ? null
    : 'De geboortedatum komt niet overeen met het stamboeknummer.';
};

export const validateSexAndRegistrationNumber = (sex, rn, rnValid) => {
  if (!rn || !sex || !rnValid || rn.charAt(0) === '3') {
    return null;
  }
  return (rn.charAt(0) === '1' && sex === 'MALE') || (rn.charAt(0) === '2' && sex === 'FEMALE')
    ? null
    : 'De aanspreektitel komt niet overeen met het stamboeknummer.';
};

export const getTitleErrors = (sex, registrationNumber, registrationNumberValid) => {
  const titleErrors = [];
  if (!sex) {
    titleErrors.push({
      code: 'title.required',
      message: 'De aanspreektitel is verplicht',
    });
  }
  if (validateSexAndRegistrationNumber(sex, registrationNumber, registrationNumberValid)) {
    titleErrors.push({
      code: 'title.does.not.match.registrationnumber',
      message: 'De aanspreektitel komt niet overeen met het stamboeknummer',
    });
  }
  return titleErrors;
};

export const getDateOfBirthErrors = (dateOfBirth, registrationNumber, registrationNumberValid) => {
  const dateOfBirthErrors = [];
  if (
    validateDateOfBirthAndRegistrationNumber(
      dateOfBirth,
      registrationNumber,
      registrationNumberValid
    )
  ) {
    dateOfBirthErrors.push({
      code: 'dateofbirth.does.not.match.registrationnumber',
      message: 'De geboortedatum komt niet overeen met het stamboeknummer',
    });
  }
  if (isAfter(dateOfBirth, getPreviousYear(getNow(), 2))) {
    dateOfBirthErrors.push({
      code: 'dateofbirth.too.late',
      message: 'Het jaartal van de geboortedatum klopt niet.',
    });
  }
  return dateOfBirthErrors;
};

export const validatePasswordStrength = (password) => {
  const lengthMessage =
    'Het wachtwoord moet tussen 8 en 25 karakters bevatten.';

  const rulesMessage =
    'Je wachtwoord moet voldoen aan 3 van de 4 volgende voorwaarden: ' +
    'min 1 hoofdletter en/of min 1 cijfer en/of min 1 kleine letter en/of min 1 speciaal karakter. ' +
    'Je mag je gebruikersnaam niet opnemen in je wachtwoord. ' +
    'Deze speciale karakters wel: @ # $ % ^ & * - _ ! + = [ ] { } | \\ : \' , . ? / ` ~ " ( ) ; < >. ';


  if (password.length < 8 || password.length > 25) {
    return {
      code: 'password.invalid.length',
      message: lengthMessage,
    };
  }

  const allowedCharsRegex = /^[A-Za-z0-9 @#$%^&*\-_!+=\[\]{}\|\\:',.?/`~"();<>]*$/;
  if (!allowedCharsRegex.test(password)) {
    return {
      code: 'password.invalid.unicode',
      message: rulesMessage,
    };
  }

  const rules = [
    '[A-Z]', // uppercase
    '[0-9]', // digit
    '[a-z]', // lowercase
    '[@#\\$%\\^&\\*\\-_!\\+=\\[\\]\\{\\}\\|\\\\:\',\\.\\?/`~"();<>]' // allowed special chars
  ];

  let matches = 0;
  rules.forEach((rule) => {
    if (password.match(rule)) matches += 1;
  });

  if (matches < 3) {
    return {
      code: 'password.too.weak',
      message: rulesMessage,
    };
  }

  return null;
};
